module.exports = __webpack_public_path__ + "static/githubLit-29190baa96878cafd2bfa2db94fc14f2.png";